import React, { Component } from 'react'
import { StyledPageLoader, BallRotate } from './PageLoader.styles'

export class PageLoader extends Component {
  render() {
    return (
      <StyledPageLoader data-testid={'page-loader'} active>
        <BallRotate>
          <div />
        </BallRotate>
      </StyledPageLoader>
    )
  }
}

export default PageLoader
